import React, { FC } from 'react'
import { useTranslation } from 'next-i18next'
import type { PaginationInterface } from './Hooks/paginationHookTypes.d'
import cn from 'classnames'
import s from './PaginationToolbarStyle.module.scss'

type Props = {
    pageControl: PaginationInterface
}

export const ItemsCount: FC<Props> = ({ pageControl }) => {
    const { t } = useTranslation()
    const { pageSize, currentPage, totalCount } = pageControl
    const itemsStart = (currentPage - 1) * Number(pageSize) + 1
    const itemEnd = Math.min(itemsStart + Number(pageSize) - 1, totalCount)

    return (
        <div className={cn(s['items-count'], 'pagination-items-count')}>
            <span>
                {t(
                    'Items {{itemsStart}} to {{itemEnd}} of {{totalCount}} total',
                    { itemsStart, itemEnd, totalCount }
                )}
            </span>
        </div>
    )
}
